export default "__VITE_ASSET__6835a135__"